import React, { ReactNode } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './Action.module.css';

interface ActionProps {
  icon: ReactNode;
  text?: string | null;
  onClick: () => void;
}

const Action = (props: ActionProps) => {
  const { icon, text, onClick } = props;

  const { bodytextDefaultNone, buttonsPrimaryDefault } = useTheme();

  const handleClick = () => {
    onClick();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== '[enter]') return;
    onClick();
  };

  return (
    <div
      className={styles.container}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={buttonsPrimaryDefault}
    >
      <div className={styles.icon}>{icon}</div>
      <p
        className={styles.text}
        style={{ ...bodytextDefaultNone, color: 'white' }}
      >
        {text}
      </p>
    </div>
  );
};

export default Action;
